'use client';

import Image, { type ImageProps } from 'next/image';
import { useState } from 'react';

/**
 * Image component that gracefully hides itself when the source fails to load.
 * Use in place of next/image for GCS-hosted images that may not exist yet.
 */
export function FallbackImage(props: ImageProps) {
  const [failed, setFailed] = useState(false);

  if (failed) return null;

  return <Image {...props} onError={() => setFailed(true)} />;
}
